import { render } from "./SelectSupervisor.vue?vue&type=template&id=65e8136c"
import script from "./SelectSupervisor.vue?vue&type=script&lang=js"
export * from "./SelectSupervisor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__